module.exports = __webpack_public_path__ + "img/385c895272e285351bbd1a5673395850.jpg";